<mat-card-content>
  <ng-content></ng-content>
</mat-card-content>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/article/article-content/article-content.component.html